import { Text, TextProps } from '@mantine/core';

interface BalanceTextProps extends TextProps {
  /** formatted balance ("-3hrs 0min") or seconds */
  value: string | number;
  formatted?: string;
}

/** Bold balance: red when negative, green when positive, neutral at zero. */
export function BalanceText({ value, formatted, ...props }: BalanceTextProps) {
  const text = formatted ?? String(value);
  const isNegative =
    typeof value === 'number' ? value < 0 : text.trim().startsWith('-');
  const isZero =
    typeof value === 'number' ? value === 0 : /^0\D+0\D*$/.test(text.trim());

  return (
    <Text
      fw="bold"
      color={isNegative ? 'red' : isZero ? 'dimmed' : 'teal.6'}
      {...props}
    >
      {text}
    </Text>
  );
}
